import React from 'react';
import { useRecoilValue } from 'recoil';

import { onboardingTestIDs } from '@constants';
import { screenReaderEnabledState } from '@store';

import { OnboardingFreeTrialContent } from './components/OnboardingFreeTrialContent';

import { TWCPage } from '../../components/primitives/TWCPage/TWCPage';

export const OnboardingFreeTrialPage = () => {
  const screenReaderEnabled = useRecoilValue(screenReaderEnabledState);

  return (
    <TWCPage
      childIds={[onboardingTestIDs.onboardingFreeTrial.doneButton, onboardingTestIDs.onboardingFreeTrial.step1Section]}
      firstFocus={
        screenReaderEnabled
          ? onboardingTestIDs.onboardingFreeTrial.step1Section
          : onboardingTestIDs.onboardingFreeTrial.doneButton
      }
      hasBackground={false}
      pageID={onboardingTestIDs.pages.onboardingFreeTrialPage}
    >
      <OnboardingFreeTrialContent.API />
    </TWCPage>
  );
};
